export const storageKey = {
  BoucherBannerVisible: "BoucherBannerVisible",
}

const keyPrefix = "Hackle:"

export const getFromSessionStorage = (key: string) => {
  const item = sessionStorage.getItem(`${keyPrefix}${key}`) ?? JSON.stringify(null)

  return JSON.parse(item)
}

export const setToSessionStorage = (key: string, value: unknown) => {
  sessionStorage.setItem(`${keyPrefix}${key}`, JSON.stringify(value))
}
